export interface ParametersState {
  ruleSets: Array<Ruleset>;
  propertyValueAttributes: Array<PropertyValueAttribute>;
  tags: Array<Tag>;

  newPropertyValueAttribute?: PropertyValueAttribute;
  newRuleset: Ruleset;
  newTag: Tag;

  getting: boolean;
  deleting: boolean;
  posting: boolean;
}

export enum RulesetKeys {
  NAME = "name",
  DESCRIPTION = "description",
}

export interface Ruleset {
  id: string;
  [RulesetKeys.NAME]: string;
  [RulesetKeys.DESCRIPTION]: string;
}

export enum TagKeys {
  NAME = "name",
  DESCRIPTION = "description",
  CATEGORY = "category",
}

export interface Tag {
  id: string;
  [TagKeys.NAME]: string;
  [TagKeys.DESCRIPTION]: string;
  [TagKeys.CATEGORY]: string;
}

export enum TagCategoryEnum {
  NONE = "",
  UI_LOCATION = "UI_LOCATION",
  LINEITEM = "LINEITEM",
  OPT_CATEGORY = "OPT_CATEGORY",
  ACC_CATEGORY = "ACC_CATEGORY",
  WAR_CATEGORY = "WAR_CATEGORY",
  QC_CATEGORY = "QC_CATEGORY",
  STARTUP_CATEGORY = "STARTUP_CATEGORY",
  MISC = "MISC",
}

export const TagCategoryOptions = [
  { name: "Uncategorized", value: TagCategoryEnum.NONE },
  { name: "UI Location", value: TagCategoryEnum.UI_LOCATION },
  { name: "Quote Line Item", value: TagCategoryEnum.LINEITEM },
  { name: "Option Category", value: TagCategoryEnum.OPT_CATEGORY },
  { name: "Accessory Category", value: TagCategoryEnum.ACC_CATEGORY },
  { name: "Warranty Category", value: TagCategoryEnum.WAR_CATEGORY },
  { name: "Quote Control Category", value: TagCategoryEnum.QC_CATEGORY },
  { name: "Startup Category", value: TagCategoryEnum.STARTUP_CATEGORY },
  { name: "Miscellaneous", value: TagCategoryEnum.MISC },
];

export enum PropertyValueAttributeKeys {
  NAME = "name",
  DATATYPE = "dataType",
  ISVALUEEDITABLE = "isValueEditable",
  ISTYPEEDITABLE = "isTypeEditable",
  ISDELETEABLE = "isDeleteable",
  ISSELECCTEDBYDEFAULT = "isSelectedByDefault",
}

export interface PropertyValueAttribute {
  id: string;
  [PropertyValueAttributeKeys.NAME]: string;
  [PropertyValueAttributeKeys.DATATYPE]: string;
  [PropertyValueAttributeKeys.ISDELETEABLE]: boolean;
  [PropertyValueAttributeKeys.ISSELECCTEDBYDEFAULT]: boolean;
  [PropertyValueAttributeKeys.ISTYPEEDITABLE]: boolean;
  [PropertyValueAttributeKeys.ISVALUEEDITABLE]: boolean;
}

export enum StandardPVAs {
  Attribute1 = "Attribute1",
  Attribute2 = "Attribute2",
  Attribute3 = "Attribute3",
  Attribute4 = "Attribute4",
  Attribute5 = "Attribute5",
  Brand = "Brand",
  CapacityImpact = "CapacityImpact",
  CategoryOrder = "CategoryOrder",
  ControlType = "ControlType",
  Description = "Description",
  EfficiencyImpact = "EfficiencyImpact",
  Enabled = "ENABLED",
  EquipReportDesc = "EquipReportDesc",
  ExtDesc = "ExtDesc",
  Image = "Image",
  IsAvailable = "IsAvailable",
  IsStandard = "IsStandard",
  MLP = "MLP",
  Note = "Note",
  OperWeight = "OperWeight",
  Order = "Order",
  PN = "PN",
  PriceKey = "PriceKey",
  Qty = "QTY",
  QtyMayHave = "QTY_MayHave",
  QtyMustHave = "QTY_MustHave",
  ReportDesc = "ReportDesc",
  RoundDigits = "RoundDigits",
  RoundMethod = "RoundMethod",
  Ruleset = "RULESET",
  ShipWeight = "ShipWeight",
  SoundImpact = "SoundImpact",
  Tos = "TOS",
  Value = "Value",
  Visible = "VISIBLE",
}
